export default function adjustFontSizeToFit(element, indic) {
  //console.log("ajustFontSize")
  var elementWidth = element.getBBox().w
  var rectWidth = element.parent().select('rect') ? element.parent().select('rect').getBBox().w : 0
  if (indic == false) {
    //console.log("ok")
    if (rectWidth > 0 && elementWidth > rectWidth) {
      if(element.node.style.fontSize == ''){
        //console.log("no fontSize")
        element.node.style.fontSize = '200px';
        elementWidth = element.getBBox().w;
        const ratio = elementWidth / rectWidth / 0.90
        element.node.style.fontSize = `${200 / ratio}px`
      }else{
        //console.log("fontSize")
        const ratio = elementWidth / rectWidth / 0.90
        const fontSize = Number.parseInt(getComputedStyle(element.node).fontSize.replace('px'), 10)
        element.node.style.fontSize = `${fontSize / ratio}px`
      }
    }
  } else if (indic == true) {
    //if indic has rect
    if (rectWidth > 0) {
      if (elementWidth < rectWidth) {
        const ratio = elementWidth / rectWidth / 0.95
        const fontSize = Number.parseInt(getComputedStyle(element.node).fontSize.replace('px'), 10)
        element.node.style.fontSize = `${fontSize / ratio}px`
      } else if (elementWidth > rectWidth) {
        const ratio = elementWidth / rectWidth / 0.95
        const fontSize = Number.parseInt(getComputedStyle(element.node).fontSize.replace('px'), 10)
        element.node.style.fontSize = `${fontSize / ratio}px`
      }
    //if not 
    }else{

      var originalNum = element.node.innerHTML;
      if(element.attr('si:bindicw')===null){
        element.node.innerHTML = "XXX";
        rectWidth = element.getBBox().w;
        element.attr('si:bindicw', rectWidth);
      }else{
        rectWidth = parseFloat(element.attr('si:bindicw')); 
      }
      element.node.innerHTML = originalNum;
      elementWidth = element.getBBox().w;
      
      const fontSize = Number.parseInt(getComputedStyle(element.node).fontSize.replace('px'), 10)

      
      if (elementWidth < rectWidth) {
        const ratio = elementWidth / rectWidth / 0.95
        element.node.style.fontSize = `${fontSize / ratio}px`
      } else if (elementWidth > rectWidth / 0.95) {
        const ratio = elementWidth / rectWidth / 0.95
        element.node.style.fontSize = `${fontSize / ratio}px`
      }
    }

  }
}
